module.exports = __webpack_public_path__ + "static/image-05-a@2x-92af9cf58bf9a006f0b9b2920e9e27c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/designmuseum/image-05-a@2x.jpg
// module id = 372
// module chunks = 3627797113349 20562973939449 33019919093843